export const SIGN_UP = "SIGN_UP";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGOUT = "LOGOUT";
export const GET_CELEBS = "GET_CELEBS";
export const GET_CELEBS_SUCCESS = "GET_CELEBS_SUCCESS";
export const GET_CELEBS_FAILED = "GET_CELEBS_FAILED";
export const PUT_SCORE = "PUT_SCORE";
export const PUT_SCORE_SUCCESS = "PUT_SCORE_SUCCESS";
export const PUT_SCORE_FAILED = "PUT_SCORE_FAILED";
export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILED = "GET_USERS_FAILED";
export const GET_HIGHSCORES = "GET_HIGHSCORES";
export const GET_HIGHSCORES_SUCCESS = "GET_HIGHSCORES_SUCCESS";
export const GET_HIGHSCORES_FAILED = "GET_HIGHSCORES_FAILED";